import filterSettings from './filterSettings/main'

export default {
    noEvents: "Zurzeit sind keine Veranstaltungen geplant.",
    noAppointments: "Zurzeit sind keine Termine geplant.",

    showMoreDetails: "Details anzeigen",
    showLessDetails: "Details ausblenden",
    registration: "Anmelden",
    bookedOut: "Ausgebucht",
    waitingList: "Warteliste",
    registrationPlanned: "Anmeldung ab {registrationStart} freigeschalten",
    registrationPlannedShort: "Anmeldung ab {registrationStart}",

    onlineEventApp: "Online über",
    onlineEvent: "Online Angebot",
    online: "Online Angebot",

    from: "Ab",
    to: "bis",
    years: "Jahre",
    freeOfCharge: "Kostenlos",
    chargeable: "Kostenpflichtig",

    //tabs
    info: "Informationen",
    faq: "Häufig gestellte Fragen",
    speakers: "Referierende",
    team: "Team",
    eventPlace: "Veranstaltungsort",
    noEventPlaceFound: "Kein Veranstaltungsort gefunden",
    placeholderExternalContent: "🛈 Externe Inhalte",
    showExternalContent: 'Externe Inhalte anzeigen',
    thirdPartyContent: 'Zum Schutz Ihrer Daten werden externe Inhalte nicht angezeigt. Klicken Sie hier um ' +
        'diese Inhalte anzeigen zu lassen.',

    description: "Beschreibung",
    services: "Leistungen",

    catering: "Verpflegung",
    accommodation: "Unterbringung",
    travelDocuments: "Reiseunterlagen",
    moreInfoLink: "Weitere Infos",
    arrivalDirections: "Anreise",
    otherServices: "Sonstige Leistungen",

    details: "Details",

    location: "Ort",
    occupancy: "Belegung",
    freePlaces: "Für diese Veranstaltung sind noch Plätze frei.",
    fewPlaces: "Für diese Veranstaltung sind nur noch wenige Plätze frei.",
    isBookedOut: "Diese Veranstaltung ist leider bereits ausgebucht.",
    registerToWaitingList: "Sie können sich jedoch noch auf eine Warteliste anmelden.",

    offerNumber: "Angebotsnummer",

    participants: "Teilnehmende",
    minParticipants: "mindestens kein|mindestens ein|mindestens {count}",
    and: "und",
    maxParticipants: "maximal kein|maximal ein|maximal {count}",
    minParticipantsMustBeReachedUntil: "Mindestteilnehmerzahl muss bis zum {date} erreicht werden",


    registrationDeadline: "Anmeldeschluss",
    additionalDates: "Weitere Termine",
    priceDetails: "Preisgestaltung",
    organizer: "Veranstalter",

    documents: "Unterlagen",
    terms: "Teilnahmebedingungen",
    privacy: "Datenschutz",
    infoSheet: "Infoblatt",

    processing: "Sachbearbeitung",
    phone: "Telefon",
    mail: "E-Mail",
    contactHours: "Kontaktzeiten",
    imageOf: "Bild von",

    lowBarrier: "Barrierearm",

    backToMap: "Zur Kartenansicht",
    backToCalendar: "Zum Kalender",
    backToList: "Zur Übersicht",

    copiedToClipboard: "In die Zwischenablage kopiert",
    subscribeCalendar: "Kalender abonnieren",
    copyIcalUrl: "URL kopieren",
    downloadIcalFile: "Datei herunterladen",

    showMap: "Karte anzeigen",
    mapboxLegalNoticeAll: "Wenn Sie Veranstaltungsorte auf dieser Seite sehen möchten, werden personenbezogene " +
        "Daten an den Betreiber der Karte gesendet. Daher ist es möglich, dass der Anbieter Ihre Zugriffe " +
        "speichert und Ihr Verhalten analysieren kann. Die Datenschutzerklärung von Mapbox finden Sie unter:",
    mapboxLegalNotice: "Wenn Sie den Veranstaltungsort auf dieser Seite sehen möchten, werden personenbezogene " +
        "Daten an den Betreiber der Karte gesendet. Daher ist es möglich, dass der Anbieter Ihre Zugriffe " +
        "speichert und Ihr Verhalten analysieren kann. Die Datenschutzerklärung von Mapbox finden Sie unter:",

    addToCalendar: 'Zum Kalender hinzufügen',
    downloadIcal: 'Outlook® / iCal®',
    openOutlookCom: 'Outlook.com Kalender',
    openGoogleCalendar: 'Google Kalender™',

    continuously: "Dauerhaft",
    noSuchEvent: "Diese Veranstaltung wurde nicht gefunden",
    noSuchAppointment: "Dieser Termin wurde nicht gefunden",
    moreEvents: "Mehr Veranstaltungen anzeigen",
    moreAppointments: "Mehr Termine anzeigen",

    noFundraisers: "Zurzeit laufen keine Spendenaktionen",
    noProjects: "Zurzeit laufen keine Spendenprojekte",
    fundraiserDeactive: "Diese Spendenaktion wird nicht mehr angezeigt",

    donationSumInfoPre: "Bereits",
    donationSumInfoPost: "gespendet!",

    projects: "Projekte",
    donation: "Jetzt Spenden",


    progress: {
        stillMissing: "Uns fehlen noch ",
        beTheFirst: "Helfen Sie mit der ersten Spende für dieses Projekt!",
        pleaseHelpDonating: ", bitte helfen Sie uns dabei das Spendenziel zu erreichen.",
        achievedGoal: "Wir konnten unser Spendenziel bereits erreichen! Trotzdem freuen wir uns sehr über jede weitere Spende."
    },

    filterSettings
}
